import { MessageCircle, Mail } from "lucide-react";
import { WHATSAPP_URL, WHATSAPP_DISPLAY, EMAIL } from "./constants";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-champagne/10 bg-ebony">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div>
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-3xl italic text-gold">KS</span>
            <span className="text-xs uppercase tracking-[0.3em] text-cream/80">
              Kiara Samson
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-cream/45">
            Elite on-site horse training &amp; instruction — at your stables
            across Dubai, exclusively for female horse owners.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="flex items-center gap-3 text-sm font-light text-cream/60 transition-colors duration-300 hover:text-gold"
          >
            <MessageCircle size={16} strokeWidth={1.5} className="text-gold" />
            {WHATSAPP_DISPLAY}
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-sm font-light text-cream/60 transition-colors duration-300 hover:text-gold"
          >
            <Mail size={16} strokeWidth={1.5} className="text-gold" />
            {EMAIL}
          </a>
        </div>
      </div>
      <div className="hairline-gold mt-14" />
      <p className="mt-8 text-[11px] font-light tracking-wide text-cream/30">
        © 2026 Kiara Samson · Exclusively for female horse owners · Winter
        season October — May
      </p>
    </div>
  </footer>
);

export default Footer;
